<template>
  <div class="sl-root" :style="themePageStyle">
  <head>
    <meta charset="utf-8" /><title>FLOCKR | Saved Listings</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/custom.css" rel="stylesheet" type="text/css" />
  </head>
  <body data-sidebar="dark">
  <div id="layout-wrapper">
    <nav class="sl-topbar">
      <div class="container d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center" style="gap:16px;">
          <a href="javascript:void(0)" @click="$router.push('/')"><img src="assets/images/flockr_logo.png" alt="Flockr" style="height:34px;" /></a>
          <span class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:15px;"><i class="mdi mdi-heart me-1" style="color:#FF6B6B;"></i>Saved Listings</span>
        </div>
        <a href="javascript:void(0)" @click="$router.push('/marketplace/saved-searches')" style="color:#BFA164;font-size:13px;text-decoration:none;">Saved Searches</a>
      </div>
    </nav>

    <div class="container sl-container">
      <div v-if="loading" class="text-center py-5"><div class="spinner-border text-warning"></div></div>

      <div v-else-if="listings.length === 0" class="text-center py-5">
        <i class="mdi mdi-heart-off-outline" style="font-size:64px;color:var(--fm-s,#3A3530);"></i>
        <h5 class="mt-3" style="color:var(--fm-h,#F5F0E8);">No Saved Listings</h5>
        <p style="color:var(--fm-s,#6B6356);">Tap the heart icon on any listing to save it here.</p>
        <button class="btn btn-warning mt-2" @click="$router.push('/marketplace')"><i class="mdi mdi-storefront-outline me-1"></i> Browse Marketplace</button>
      </div>

      <div v-else class="row g-3">
        <div class="col-6 col-md-4 col-lg-3" v-for="item in listings" :key="item.id">
          <div class="sl-card" @click="$router.push('/marketplace/listing/' + item.id)">
            <div class="sl-img">
              <img v-if="item.primary_photo" :src="photoUrl(item.primary_photo)" :alt="item.title" />
              <i v-else class="mdi mdi-paw" style="font-size:36px;color:rgba(191,161,100,0.3);"></i>
              <button class="sl-unsave-btn" @click.stop="unsave(item)"><i class="mdi mdi-heart text-danger"></i></button>
            </div>
            <div class="sl-body">
              <div class="sl-title">{{ item.title }}</div>
              <div class="sl-price">KES {{ formatPrice(item.price) }}</div>
              <div class="sl-meta">{{ item.species_name }} <span v-if="item.county_name">· {{ item.county_name }}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </body>
  </div>
</template>
<style>

/* === GLOBAL THEME === */
html[data-theme="light"] body { background:#FFFFFF!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-card,html[data-theme="light"] .p2c,html[data-theme="light"] .ld-section,html[data-theme="light"] .ld-action-card,html[data-theme="light"] .ld-seller-card,html[data-theme="light"] .ld-info-card,html[data-theme="light"] .ld-related-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-overlay .fm-modal,html[data-theme="light"] .ad-overlay .ad-modal { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-input,html[data-theme="light"] .fm-select { background:#F7F5F2!important; border-color:#E0D8D0!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-label { color:#555!important; }
html[data-theme="dark"] body { background:#0A0A0A!important; color:#F5F0E8!important; }
</style>
<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] body{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .card{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .card-body{color:#1A1A1A!important}
html[data-theme="light"] .modal-content{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#1A1A1A!important}
html[data-theme="light"] .form-control,html[data-theme="light"] .form-select{background:#FFFFFF!important;border-color:#E0D8D0!important;color:#1A1A1A!important}
html[data-theme="light"] .table{color:#1A1A1A!important}
html[data-theme="light"] .table th{color:#555!important;border-color:#E8E2DA!important}
html[data-theme="light"] .table td{border-color:#F0EBE4!important}
html[data-theme="light"] [style*="color:#F5F0E8"]{color:#1A1A1A!important}
html[data-theme="light"] [style*="color:#6B6356"]{color:#777!important}
html[data-theme="light"] [style*="color:#A09888"]{color:#555!important}
html[data-theme="light"] [style*="background:#0F0F0F"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#141414"]{background:#FFFFFF!important}
html[data-theme="light"] [style*="background:#1E1E1E"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="background:#0A0A0A"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#1a1510"]{background:#FFF8F0!important}
html[data-theme="light"] [style*="background:#1A1A1A"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="border:1px solid #1E1E1E"]{border-color:#E8E2DA!important}
html[data-theme="light"] [style*="border:1px solid #2A2520"]{border-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1A1A1A"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1E1E1E"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #2A2520"]{border-bottom-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-top:1px solid #2A2520"]{border-top-color:#E0D8D0!important}
html[data-theme="light"] [style*="color:#BFA164"]{color:#BFA164!important}
html[data-theme="light"] [style*="color:#50C878"]{color:#50C878!important}
html[data-theme="light"] [style*="color:#4FC3F7"]{color:#4FC3F7!important}
html[data-theme="light"] [style*="color:#FF6B6B"]{color:#FF6B6B!important}
html[data-theme="light"] [style*="color:#FF9800"]{color:#FF9800!important}
html[data-theme="light"] [style*="color:#CE93D8"]{color:#CE93D8!important}
</style>
<style scoped>
.sl-root{background:var(--fm-bg2,#0F0F0F)!important;min-height:100vh}
.sl-topbar{position:sticky;top:0;z-index:100;padding:12px 0;background:rgba(10,10,10,.95)!important;backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.sl-container{padding-top:80px;padding-bottom:60px;max-width:1140px}
.sl-card{background:var(--fm-bg1,#141414)!important;border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;overflow:hidden;cursor:pointer;transition:all .2s}
.sl-card:hover{border-color:#BFA164;transform:translateY(-2px)}
.sl-img{position:relative;height:150px;overflow:hidden;background:var(--fm-bg2,#0F0F0F)!important;display:flex;align-items:center;justify-content:center}
.sl-img img{width:100%;height:100%;object-fit:cover}
.sl-unsave-btn{position:absolute;top:8px;right:8px;background:rgba(0,0,0,.5)!important;border:none;border-radius:50%;width:30px;height:30px;display:flex;align-items:center;justify-content:center;color:#FF6B6B!important;cursor:pointer}
.sl-body{padding:12px}
.sl-title{font-size:13px;font-weight:600;color:var(--fm-h,#F5F0E8)!important;margin-bottom:4px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.sl-price{font-size:15px;font-weight:700;color:#BFA164!important;margin-bottom:4px}
.sl-meta{font-size:11px;color:var(--fm-s,#6B6356)!important}
@media(max-width:768px){.sl-container{padding-top:70px}.sl-img{height:120px}}
</style>
<script>
import { executeJson, flocker, uploads } from "@/api";
export default {
  name: "SavedListingsPage",
  data(){return{
      darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
loading:true,listings:[]}},
  mounted(){
    // Apply global theme
    var t=localStorage.getItem('flockr_theme')||'dark';window.__flockrSetTheme(t);
var u=sessionStorage.getItem('userId');if(!u){this.$router.push('/login');return}this.fetch()},
  computed:{
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'},
    themeCardStyle(){return this.darkMode?'background:#141414!important;border:1px solid #1E1E1E!important;':'background:#FFFFFF!important;border:1px solid #E8E2DA!important;'},
    themeInputStyle(){return this.darkMode?'background:#0F0F0F;border:1px solid #2A2520;color:#F5F0E8;':'background:#FFFFFF;border:1px solid #E0D8D0;color:#1A1A1A;'},
  },
  methods:{
    photoUrl(p){if(!p)return'';if(p.startsWith&&p.startsWith('http'))return p;return uploads+String(p).replace('uploads/','')},
    
    async fetch(){this.loading=true;try{var r=await executeJson({function:"getSavedListings",userId:sessionStorage.getItem('userId')},flocker);if(r.data.success)this.listings=r.data.data.listings||[]}catch(e){console.error(e)}this.loading=false},
    async unsave(item){try{var r=await executeJson({function:"saveListing",userId:sessionStorage.getItem('userId'),listingId:item.id},flocker);if(r.data.success)this.listings=this.listings.filter(function(l){return l.id!==item.id})}catch(e){console.error(e)}},
    formatPrice(a){return a?Number(a).toLocaleString('en-KE'):'0'}
  }
};
</script>
